import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  class: "connecting-path",
  d: "M16.5 7.5L6.5 3.5L3.5 16.5",
  "stroke-dasharray": "3 3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  stroke: "currentColor",
  fill: "currentColor",
  class: "first-point",
  cx: "6.5",
  cy: "3.5",
  r: "2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  stroke: "currentColor",
  fill: "currentColor",
  class: "second-point",
  cx: "16.5",
  cy: "7.5",
  r: "2"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("circle", {
  stroke: "currentColor",
  fill: "currentColor",
  class: "third-point",
  cx: "3.5",
  cy: "16.5",
  r: "2"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }